export enum ComplianceSource {
  NHSTemplate = 'NHSTemplate',
  NHSAskHeidi = 'NHSAskHeidi',
}

export enum ComplianceStatus {
  Warning = 'Warning',
  Blocked = 'Blocked',
}

/**
 * Compliance events describe clinician-authored content but must never carry it —
 * the payload reaches third-party analytics. Use sizes and identifiers only.
 */

/**
 * Props for NHS template compliance events.
 */
export type NHSTemplateComplianceProps = {
  source: ComplianceSource.NHSTemplate;
  status: ComplianceStatus;
  /** Character length of the noncompliant_input echoed by the compliance check */
  compliance_output_length?: number;
  /** Character length of the rejected template body */
  template_content_length?: number;
  /** The template the check was run against, where one already exists */
  template_id?: string;
  /** Source of the template (create, update, pdf, gallery_import) */
  template_source?: 'create' | 'duplicate' | 'update' | 'pdf' | 'gallery_import';
};

/**
 * Props for Ask Heidi NHS compliance events.
 */
export type NHSAskHeidiComplianceProps = {
  source: ComplianceSource.NHSAskHeidi;
  status: ComplianceStatus;
  /** Character length of the noncompliant_input echoed by the compliance check */
  compliance_output_length?: number;
  /** Character length of the rejected AI command text */
  ai_command_text_length?: number;
  /** Character length of the content/context provided with the request */
  content_length?: number;
  /** The session ID where the request was made */
  session_id?: string;
};

export type ComplianceEventProps =
  | NHSTemplateComplianceProps
  | NHSAskHeidiComplianceProps;

/** Optional detailed props for template compliance tracking functions (source/status set automatically) */
export type NHSTemplateComplianceDetailedProps = Omit<
  NHSTemplateComplianceProps,
  'source' | 'status'
>;

/** Optional detailed props for Ask Heidi compliance tracking functions (source/status set automatically) */
export type NHSAskHeidiComplianceDetailedProps = Omit<
  NHSAskHeidiComplianceProps,
  'source' | 'status'
>;
